import state from './modulePayrollState.js'
import mutations from './modulePayrollMutations.js'
import actions from './modulePayrollActions.js'
import getters from './modulePayrollGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
